import { connect } from 'react-redux';

import {
  getCategory,
  createCategory,
  updateCategory,
} from '../actions/categories';

import { categorySelector } from '../reducers/categories';

import { isLoadingSelector } from '../reducers';
import { withParams } from '../utilities/reactRouter';
import AdminCategoryPageComponent from '../components/AdminCategoryPage';

const mapStateToPros = (state, ownProps) => {
  return {
    loading: isLoadingSelector(state),
    category: categorySelector(state)(ownProps.params.id),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getCategory: (id) => dispatch(getCategory(id)),
    createCategory: (ctgr) => dispatch(createCategory(ctgr)),
    updateCategory: (id, ctgr) => dispatch(updateCategory(id, ctgr)),
  };
};

const AdminCategoryPage = withParams(
  connect(mapStateToPros, mapDispatchToProps)(AdminCategoryPageComponent)
);

export default AdminCategoryPage;


